import { Expose, Transform } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";
import { HolidayTypeEnum } from "@altertec_gparn/lib";

export class EffectiveUserHolidayDto {
  @Expose()
  collectiveAgreementHolidayId: string;

  @Expose()
  userChangeHolidayId?: string | null;

  @Expose()
  collectiveAgreementId: string;

  @Expose()
  @Transform(({ value }) => setTimeToMidday(toLocaleTimezone(parseApiDate(value))))
  originalDate: Date;

  @Expose()
  @Transform(({ value }) => setTimeToMidday(toLocaleTimezone(parseApiDate(value))))
  effectiveDate: Date;

  @Expose()
  name?: string;

  @Expose()
  type: HolidayTypeEnum;

  @Expose()
  description?: string;
}
